import * as React from 'react';
import {connect} from "react-redux";
import classnames from "classnames";
import PropTypes from "prop-types";
import {Col, Input, Row, CardBody, Tooltip} from "reactstrap";
import CheckboxIcon from "./checkboxIcon";
import RadioIcon from "./radioIcon";
import {injectIntl} from "react-intl";

function ImageOpenAnswer(props) {
	const {answer, answersImage, checkboxType, onBlur, onOpenChange, detail, showInput, showContent, isTooltipOpen, toggleTooltip, answerOpenAlwaysShow, intl, checked, rightComponent, onlyInput, leftComponent} = props

	const getDetailContent = () => {
		if (detail && typeof detail === 'object') {
			return detail.content
		}

		return detail ? detail : ""
	}

	const getAnswerContent = () => {
		if (answer && typeof answer === 'object') {
			return answer.content
		}

		return answer
	}

	const isOpened = () => {
		if (detail && typeof detail === 'object') {
			return detail && answer && answer.isOpen
		}

		return answer.isOpen;
	}

	const isChecked = () => {
		if (detail && typeof detail === 'object') {
			return detail;
		}

		return checked;
	}

	return (
		<div className={isOpened() ? "h-100 align-items-center d-flex opened" : "h-100 align-items-center d-flex"}>
			{leftComponent && <React.Fragment>
				{leftComponent}
			</React.Fragment>}
			{answersImage && <div id={`tooltip-${answer.id}`} className="img-wrap align-self-center" key={answer.id} data-id={answer.id}>
				<img src={answer.content}/>
				<Tooltip
					delay={0}
					placement="top"
					isOpen={isTooltipOpen}
					target={`tooltip-${answer.id}`}
					toggle={toggleTooltip}
				>
					{answer.description}
				</Tooltip>
			</div>}
			{!answersImage && <React.Fragment>
				{checkboxType === "checkbox" && <CheckboxIcon classes={"align-self-center"} checked={isChecked()} />}
				{checkboxType === 'radio' && <RadioIcon classes={"align-self-center"} checked={checked} />}
				<span className={classnames({
					"d-flex w-100": !showInput && !onlyInput,
					"mobile-input-wrapper": showInput,
					"d-none d-flex": onlyInput
				})}>
					{!onlyInput && <span className={classnames({
						'd-block mr-3': !showContent,
						'w-100': showContent,
						'align-self-center': true,
						'font-weight-bold': checkboxType === 'radio' || !checkboxType ? checked : detail,
						'image-open-answer': true,
						'pl-0': !checkboxType
					})} dangerouslySetInnerHTML={{__html: getAnswerContent()}} />}
					{showInput && <div className="d-flex w-100 h-100 d-lg-none"><Input placeholder={intl.formatMessage({id: 'question.input.placeholder.typeYourAnswer'})} className={classnames({
						'h-100': true,
					})} type="text" autoFocus={answerOpenAlwaysShow === false} data-id={answer.id} bsSize="sm" onChange={onOpenChange} onBlur={onBlur} value={getDetailContent()}/>
					</div>}
				</span>
			</React.Fragment>}
			{showInput && <div className="h-100 d-none d-lg-flex flex-grow-1"><Input style={{minWidth: "130px"}} placeholder={intl.formatMessage({id: 'question.input.placeholder.typeYourAnswer'})} className={classnames({
				'h-100': true,
			})} type="text" autoFocus={answerOpenAlwaysShow === false} data-id={answer.id} bsSize="sm" onChange={onOpenChange} onBlur={onBlur} value={getDetailContent()}/>
			</div>}
			{rightComponent && <React.Fragment>
				{rightComponent}
			</React.Fragment>}
		</div>
	);
}

ImageOpenAnswer.propTypes = {
	answer: PropTypes.any,
	answersImage: PropTypes.any,
	checkboxType: PropTypes.any,
	onBlur: PropTypes.any,
	onOpenChange: PropTypes.any,
	detail: PropTypes.any,
	showInput: PropTypes.any,
	showContent: PropTypes.any,
	isTooltipOpen: PropTypes.any,
	toggleTooltip: PropTypes.any,
	answerOpenAlwaysShow: PropTypes.any,
	checked: PropTypes.any,
	rightComponent: PropTypes.any
};

function mapStateToProps(state) {
	return {}
}

export default connect(mapStateToProps, {})(injectIntl(ImageOpenAnswer));